module.exports = __webpack_public_path__ + "media/images/official/award_3-613c974e5177180ec33f4ee71e30bb33.png";